import Plugin from '@ckeditor/ckeditor5-core/src/plugin'
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview'
import {icons} from '@ckeditor/ckeditor5-core'

const createCkEditor5ImageBrowserPluginSelectionJs = () => {
    return `
        function ckeditor5imagebrowserpluginselection(event) {
            const card = event.srcElement.closest('.card');

            if (card && card.getAttribute('data-ckeditor5-url') && card.getAttribute('data-ckeditor5-url') !== '') {
                const modal = card.closest('.modal');

                if (modal) {
                    const eventImageBrowserPluginSelection = new CustomEvent('ckeditor5-image-browser-plugin-selection', {
                        detail: {
                            url: card.getAttribute('data-ckeditor5-url')
                        }
                    });

                    modal.dispatchEvent(eventImageBrowserPluginSelection);
                }
            }
        }
    `
}

const createCkEditor5ImageBrowserPluginModalHtml = (modalTitle: string, buttonAbortText: string) => {
    return `
        <div class="modal-dialog modal-xl modal-ckeditor5-image-browser-plugin">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-buttons">
                        <button type="button" class="btn btn-link" data-dismiss="modal"><i class="eii--fa6-solid--xmark"></i></button>
                    </div>
                    <h4 class="modal-title">${modalTitle}</h4>
                </div>
                <div class="modal-body"></div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">${buttonAbortText}</button>
                </div>
            </div>
        </div>
    `
}

const createImageBrowserPluginModal = async (editor: any) => {
    const body = document.querySelector('body')

    const hasImageBrowserPluginModals = document.querySelector('.modal[data-ckeditor5-id]')
    if (!hasImageBrowserPluginModals) {
        const js = document.createElement('script')
        js.innerText = createCkEditor5ImageBrowserPluginSelectionJs()
        body?.append(js)
    }

    let hasImageBrowserPluginModalWithId = document.querySelector('.modal[data-ckeditor5-id=' + editor.id + ']')
    if (!hasImageBrowserPluginModalWithId) {
        const modal = document.createElement('div')
        modal.classList.add('modal')
        modal.setAttribute('tabindex', '-1')
        modal.setAttribute('data-ckeditor5-id', editor.id)

        const modalTitle = editor.sourceElement.dataset.ckeditor5ImageBrowserPluginHeader ?? 'Graphik Auswahl'
        const modalButtonAbort = editor.sourceElement.dataset.ckeditor5ImageBrowserPluginButtonAbort ?? 'Abbrechen'

        modal.innerHTML = createCkEditor5ImageBrowserPluginModalHtml(modalTitle, modalButtonAbort)

        body?.append(modal)

        hasImageBrowserPluginModalWithId = document.querySelector('.modal[data-ckeditor5-id=' + editor.id + ']')
    }

    const modalBody = hasImageBrowserPluginModalWithId?.querySelector('.modal-body')

    if (!modalBody) {
        console.log('ImageBrowserPlugin: No Modal Body found!')
        return
    }

    const modalBodyContentLoading = `<div class="ckeditor5-image-browser-plugin-gallery-grid">
        ${window.Esearcher.handler.tabs.loadingIconLarge}
    </div>`

    const modalBodyContentError = `<div class="ckeditor5-image-browser-plugin-gallery-grid">
        <div class="eii--4x">
            <i class="eii--fa6-solid--ban"></i>
        </div>
    </div>`

    modalBody.innerHTML = modalBodyContentLoading

    const modalBodyContent = await fetch('/ck_imagebrowser.php')
        .then((response) => {
            if (!response.ok) {
                throw new Error('ImageBrowserPlugin: Network response was not OK!')
            }
            return response.text()
        })
        .then((text) => {
            return text
        })
        .catch(error => {
            modalBody.innerHTML = modalBodyContentError
            console.log(error)
        })

    modalBody.innerHTML = modalBodyContent ?? modalBodyContentError
}

class ImageBrowserPlugin extends Plugin {
    init() {
        const self: any = this
        const editor = self.editor

        const buttonTooltip = editor.sourceElement.dataset.ckeditor5ImageBrowserPluginTooltip ?? 'Graphik Auswahl'

        editor.ui.componentFactory.add('imageBrowser', () => {
            const button = new ButtonView()

            button.set({
                label: buttonTooltip,
                icon: icons.image,
                withText: false,
                tooltip: true
            })

            button.on('execute', () => {
                createImageBrowserPluginModal(editor)

                const selector = '.modal[data-ckeditor5-id=' + editor.id + ']'
                $(selector).modal()
                const modalElement = document.querySelector(selector)

                modalElement?.addEventListener('ckeditor5-image-browser-plugin-selection', (e: any) => {
                    const url = e?.detail?.url
                    if (url) {
                        editor.model.change(writer => {
                            const imageUtils = editor.plugins.get('ImageUtils')
                            const src = {src: url}
                            imageUtils.insertImage(src)
                        })
                    }
                })
            })

            return button
        })
    }
}

export {
    ImageBrowserPlugin
}
